const getTimeDifference = (arrivalTimestamp, leftTimestamp) => {
  const getTimeInSeconds = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
  };

  const arrivalTimeInSeconds = getTimeInSeconds(arrivalTimestamp);
  const leftTimeInSeconds = getTimeInSeconds(leftTimestamp);

  // Handle over-midnight cases
  let diffInSeconds;
  if (leftTimeInSeconds >= arrivalTimeInSeconds) {
    diffInSeconds = leftTimeInSeconds - arrivalTimeInSeconds;
  } else {
    diffInSeconds = (24 * 3600 - arrivalTimeInSeconds) + leftTimeInSeconds;
  }

  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);

  let formatTime;

  if (hours !== 0 && minutes <= 5) {
    formatTime = `${hours} Hr`;
  } else if (hours !== 0 && minutes >= 6 && minutes <= 20) {
    formatTime = `${hours} Hr 15 Min`;
  } else if (hours !== 0 && minutes >= 21 && minutes <= 35) {
    formatTime = `${hours} Hr 30 Min`;
  } else if (hours !== 0 && minutes >= 36 && minutes <= 50) {
    formatTime = `${hours} Hr 45 Min`;
  } else if (hours !== 0 && minutes >= 51) {
    formatTime = `${hours + 1} Hr`;
  } else if (hours === 0 && minutes <= 20) {
    formatTime = `15 Min`;
  } else if (hours === 0 && minutes >= 21 && minutes <= 35) {
    formatTime = `30 Min`;
  } else if (hours === 0 && minutes >= 36 && minutes <= 50) {
    formatTime = `45 Min`;
  } else if (hours === 0 && minutes >= 51) {
    formatTime = `1 Hr`;
  }

  return formatTime;
};

export default getTimeDifference;
